import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Status: FC<IIconsProps> = ({
  color,
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="5" fill={color} />
      <path
        d="M18 7L18.8391 8.39853C20.1692 10.6153 20.1692 13.3847 18.8391 15.6015L18 17"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M6 17L5.16088 15.6015C3.83082 13.3847 3.83082 10.6153 5.16088 8.39853L6 7"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M21 6L21.5403 7.08065C23.0887 10.1775 23.0887 13.8225 21.5403 16.9193L21 18"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M3 18L2.45967 16.9193C0.911273 13.8225 0.911274 10.1775 2.45968 7.08065L3 6"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default Status;
